import { render, staticRenderFns } from "./adyen_disputes.vue?vue&type=template&id=cc975d38&"
import script from "./adyen_disputes.vue?vue&type=script&lang=js&"
export * from "./adyen_disputes.vue?vue&type=script&lang=js&"
import style0 from "./adyen_disputes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports